export default __webpack_public_path__ + "static/media/Payroll - Inner page.c21eebee.png";